<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="30%"
    @close="resetForm">
    <el-form
      ref="passwordForm"
      :model="form"
      :rules="rules"
      label-width="100px">

      <el-form-item label="用户名" prop="username">
        <el-input
          disabled
          v-model="form.username"
          placeholder="请输入用户名"
          clearable/>
      </el-form-item>

      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          v-model="form.oldPassword"
          type="password"
          placeholder="请输入旧密码"
          show-password/>
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="form.newPassword"
          type="password"
          placeholder="请输入新密码"
          show-password/>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePassword } from '@/api/login'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      visible: false,
      form: {
        username: '',
        oldPassword: '',
        newPassword: ''
      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '旧密码不能为空', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === this.form.oldPassword) {
                callback(new Error('新密码不能与旧密码相同'))
              }else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  methods: {
    showDialog() {
      this.form.username = this.name
      this.visible = true
    },
    handleSubmit() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          updatePassword(this.form).then(response => {
            this.$message.success('密码修改成功')
            this.resetForm()
            this.visible = false
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }).catch(error => {
            this.$message.error(error.message || '修改失败')
          })
        }
      })
    },
    resetForm() {
      this.$refs.passwordForm.resetFields()
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/updatePassword.vue